/**
 * Groups GMA Display Start / End markers and wraps the Shopify sections
 * between each pair in a responsive visibility container.
 */
(function () {
  const PROCESSED_ATTR = 'data-gma-display-processed';
  const PENDING_CLASS = 'gma-display-pending';

  function isDesignMode() {
    return (
      document.documentElement.classList.contains('shopify-design-mode') ||
      window.Shopify?.designMode === true
    );
  }

  function getMainSectionRoots() {
    const main = document.getElementById('MainContent');
    if (!main) return [];

    return [...main.children].filter(
      (element) =>
        element.classList.contains('shopify-section') ||
        (element.id && element.id.startsWith('shopify-section-'))
    );
  }

  function isStartSection(section) {
    return Boolean(section.querySelector('[data-gma-display="start"]'));
  }

  function isEndSection(section) {
    return Boolean(section.querySelector('[data-gma-display="end"]'));
  }

  function buildWrapperClasses(boundary) {
    const classes = ['gma-display-wrapper'];
    if (boundary.dataset.viewDesktop === 'true') classes.push('gma-view-desktop');
    if (boundary.dataset.viewTablet === 'true') classes.push('gma-view-tablet');
    if (boundary.dataset.viewMobile === 'true') classes.push('gma-view-mobile');
    return classes.join(' ');
  }

  function collectPairs(sectionRoots) {
    const stack = [];
    const pairs = [];

    sectionRoots.forEach((section) => {
      if (isStartSection(section)) {
        stack.push(section);
        return;
      }

      if (isEndSection(section) && stack.length) {
        pairs.push({ start: stack.pop(), end: section });
      }
    });

    return pairs;
  }

  function processPair({ start, end }) {
    if (start.hasAttribute(PROCESSED_ATTR)) return;

    const boundary = start.querySelector('[data-gma-display="start"]');
    if (!boundary) return;

    const wrapper = document.createElement('section');
    wrapper.className = buildWrapperClasses(boundary);

    let node = start.nextElementSibling;
    while (node && node !== end) {
      const next = node.nextElementSibling;
      wrapper.appendChild(node);
      node = next;
    }

    start.parentNode.insertBefore(wrapper, start);
    start.setAttribute(PROCESSED_ATTR, '');
    end.setAttribute(PROCESSED_ATTR, '');
    start.remove();
    end.remove();
  }

  function initGmaDisplaySections() {
    const sectionRoots = getMainSectionRoots().filter(
      (section) => !section.hasAttribute(PROCESSED_ATTR)
    );

    collectPairs(sectionRoots).forEach(processPair);
  }

  function finishInit() {
    document.documentElement.classList.remove(PENDING_CLASS);
  }

  function run() {
    if (!isDesignMode()) {
      initGmaDisplaySections();
    }

    finishInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
